import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Colour from 'color';
import dt from '../../../../shared/theme';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 72px;
  min-height: 72px;
  width: 72px;
  min-width: 72px;
  background-color: ${props => props.bgColor};
  border: 1px solid #D7DFE7;
  border-radius: 4px;
  box-shadow: 0px 1.42105px 7.10526px rgba(0, 0, 0, 0.08);

  ${props => dt(props).theme.isLarge && `
    height: 80px;
    min-height: 80px;
    width: 80px;
    min-width: 80px;
  `};
`;

const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;

  ${props => dt(props).theme.isLarge && `
    width: 68px;
  `};
`;

const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const white = Colour('white').hex();
export default function Logo({ url, color }) {
  let c;
  try {
    c = Colour(color || white);
  } catch (err) {
    c = Colour(white);
  }
  const bgColor = c.hex();
  return (
    <Container bgColor={bgColor}>
      {!!url && (
        <ImageContainer>
          <Img src={url} />
        </ImageContainer>
      )}
    </Container>
  );
}

Logo.propTypes = {
  url: PropTypes.string,
  color: PropTypes.string,
};

Logo.defaultProps = {
  url: null,
  color: null,
};
